document.addEventListener('click', (event) => {
  const checkoutButton = document.querySelector('.button-checkout');
  if (checkoutButton && checkoutButton.contains(event.target) && typeof is_draft_order !== 'undefined' && is_draft_order && window.hulkappsCheckout != undefined) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    hulkappsCheckout();
  }
}, true);